import React from "react";

import { Content } from "src/components/AddPoshmarkExtensionDialog";

import type Step from "../Step";

interface PoshmarkAddExtensionProps {
  onClose: () => void;
  onStepChange: (step: Step) => void;
}

function PoshmarkAddExtension({
  onClose,
  onStepChange,
}: PoshmarkAddExtensionProps) {
  return <Content onClose={onClose} />;
}

export default PoshmarkAddExtension;
